const defaultState = [];


export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_NOTES':
      return action.notes;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/notes.js